import { useGraphQLQuery } from '../../../customHooks/useGraphQL';
import { GET_AI_ENABLER_DATA } from '../../../graphql/queries/commonQueries';

interface Technology {
  id: string;
  name: string;
}

interface AiEnablerResponse {
  aiEnabler: {
    fetch: Technology[];
  };
}

/**
 * Hook to fetch AI Enabler/Technology data using GraphQL
 * Returns the raw data, loading state, error, and a convenient technologies array
 */
export const useAiEnablerData = () => {
  const { data, loading, error } = useGraphQLQuery<AiEnablerResponse>(GET_AI_ENABLER_DATA, {
    v1: {},
    v2: ['name'],
  });

  return {
    aiEnablerData: data,
    aiEnablerLoading: loading,
    aiEnablerError: error,
    technologies: data?.aiEnabler?.fetch || [],
    technologyNames: (data?.aiEnabler?.fetch || []).map((tech) => tech.name),
  };
};
